export interface IConfigTipoDocumento {
    id?: number;
    descricao?: string | null;
    qtdeGerada?: number | null;
    qtdeDestruida?: number | null;
    tipo?: number | null;
  }

  export class ConfigTipoDocumento implements IConfigTipoDocumento {
    constructor(
      public id?: number,
      public descricao?: string | null,
      public qtdeGerada?: number | null,
      public qtdeDestruida?: number | null,
      public tipo?: number | null
    ) {}
  }

  export function getConfigTipoDocumentoIdentifier(configTipoDocumento: IConfigTipoDocumento): number | undefined {
    return configTipoDocumento.id;
  }
